export const labels: Record<string, string> = {
  Draft: "پیش‌نویس", Published: "منتشرشده", Archived: "بایگانی",
  PendingPayment: "در انتظار پرداخت", Paid: "پرداخت‌شده", PaymentReview: "نیازمند بررسی پرداخت", Processing: "در حال پردازش",
  Shipped: "ارسال‌شده", Delivered: "تحویل‌شده", Cancelled: "لغوشده", Refunded: "مرجوع‌شده",
  Succeeded: "موفق", Failed: "ناموفق",
  Pending: "در انتظار", Approved: "تأییدشده", Rejected: "ردشده",
  InProgress: "در حال پیگیری", Resolved: "حل‌شده", Closed: "بسته‌شده",
  Women: "زنانه", Men: "مردانه", Unisex: "یونیسکس",
  New: "جدید", Popular: "محبوب", Niche: "نیش", BestSeller: "پرفروش", Special: "ویژه",
  Percentage: "درصدی", FixedAmount: "مبلغ ثابت",
};
export const labelOf = (value?: string | null) => (value ? labels[value] ?? value : "—");
